<script setup lang="ts">
const {
  label = '订阅 Nuxt 官方通讯',
  description = '此中文镜像不收集邮箱。你可以前往 Nuxt 官网完成订阅。'
} = defineProps<{
  label?: string
  description?: string
}>()
</script>

<template>
  <div class="space-y-3">
    <div>
      <p class="font-semibold text-highlighted">
        {{ label }}
      </p>
      <p class="mt-1 text-sm text-muted">
        {{ description }}
      </p>
    </div>
    <UButton
      label="前往 Nuxt 官网订阅"
      to="https://nuxt.com/newsletter"
      target="_blank"
      rel="noopener noreferrer"
      color="neutral"
      variant="outline"
    />
  </div>
</template>
